import React from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { useCreateFeatureFlag } from 'iron/apps/feature-flags/src/components/hooks/useCreateFeatureFlag';
import { LENGTH, SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightReact } from 'common/components/text-highlight';
import { buildNewFeatureFlag } from 'apps/feature-flags/src/api/feature-flags';
import styles from './index.module.styl';
export function FeatureFlagListHeader() {
  const i18n = useTranslation();
  const createFeatureFlag = useCreateFeatureFlag();
  const handleCreateFeatureFlag = React.useCallback(() => {
    createFeatureFlag(buildNewFeatureFlag());
  }, [createFeatureFlag]);
  return <div className={styles.container} data-sentry-component="FeatureFlagListHeader" data-sentry-source-file="index.tsx">
      <div className={styles.title}>
        {i18n.t("feature-flags.list.title")}
        <div className={styles.beta}>
          <TextHighlightReact theme={TEXT_HIGHLIGHT_THEME.INFORMATION} size={SIZE.LARGE} length={LENGTH.WIDE} text={i18n.t("common.beta")} data-sentry-element="TextHighlightReact" data-sentry-source-file="index.tsx" />
        </div>
      </div>
      <ButtonReact icon='plus' theme={ButtonTheme.Primary} onClick={handleCreateFeatureFlag} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
        {i18n.t("feature-flags.list.new")}
      </ButtonReact>
    </div>;
}